(() => {
  'use strict';

  const aiImageSelector = 'img[alt^="KI_"], img[alt^="KI-"]';
  const labelledAttribute = 'data-ai-generated-labelled';
  const aiImageLabels = new WeakMap();

  const getVisualElement = (image) => image.closest('picture') || image;

  const getExistingLabel = (image) => {
    const storedLabel = aiImageLabels.get(image);

    if (storedLabel?.isConnected) {
      return storedLabel;
    }

    const sibling = getVisualElement(image).nextElementSibling;

    if (sibling?.classList.contains('ai-generated-image-label')) {
      return sibling;
    }

    return null;
  };

  const syncLabelState = (image, label) => {
    const responsiveVisibilityClasses = Array.from(image.classList).filter((className) =>
      className.startsWith('hidden-')
    );

    label.className = ['ai-generated-image-label', ...responsiveVisibilityClasses].join(' ');
    label.hidden = image.hasAttribute('hidden');
  };

  const removeAiImageLabel = (image) => {
    getExistingLabel(image)?.remove();
    aiImageLabels.delete(image);
    image.removeAttribute(labelledAttribute);
  };

  const labelAiImage = (image) => {
    if (!image.matches(aiImageSelector)) {
      if (image.getAttribute(labelledAttribute) === 'true') {
        removeAiImageLabel(image);
      }

      return;
    }

    const visualElement = getVisualElement(image);
    const wrapper = visualElement.parentElement;

    if (!wrapper) {
      return;
    }

    let label = getExistingLabel(image);

    if (!label) {
      label = document.createElement('span');
      label.className = 'ai-generated-image-label';
      label.setAttribute('aria-hidden', 'true');
      label.textContent = 'A.I. generated';
      visualElement.insertAdjacentElement('afterend', label);
    }

    if (window.getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }

    syncLabelState(image, label);
    aiImageLabels.set(image, label);
    image.setAttribute(labelledAttribute, 'true');
  };

  const processAiImages = (root) => {
    if (root instanceof Element && root.matches(aiImageSelector)) {
      labelAiImage(root);
    }

    root.querySelectorAll?.(aiImageSelector).forEach(labelAiImage);
  };

  processAiImages(document);

  const aiImageObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            processAiImages(node);
          }
        });

        return;
      }

      if (mutation.target instanceof HTMLImageElement) {
        labelAiImage(mutation.target);
      }
    });
  });

  aiImageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['alt', 'class', 'hidden']
  });
})();

(() => {
  const scrollToAngebote = () => {
    const el = document.getElementById('angebote-vetstarter');
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  };

  const hashIsAngebote = () => {
    const hash = decodeURIComponent((location.hash || '').replace(/^#/, ''));
    return hash === 'angebote-vetstarter';
  };

  const tryScroll = () => {
    if (!hashIsAngebote()) return;
    if (scrollToAngebote()) return;
    let n = 0;
    const timer = setInterval(() => {
      n += 1;
      if (scrollToAngebote() || n > 20) clearInterval(timer);
    }, 100);
  };

  document.addEventListener('DOMContentLoaded', tryScroll);
  window.addEventListener('hashchange', tryScroll);
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="angebote-vetstarter"]');
    if (!link) return;
    const el = document.getElementById('angebote-vetstarter');
    if (!el) return;
    event.preventDefault();
    if (history.replaceState) {
      history.replaceState(null, '', link.getAttribute('href'));
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
